import type { AnyID } from '@types'
import {
  isModularCornerSnapCatalog,
  isOreja,
  isPouff,
} from '@utils/sceneObjects/items/rinconeroUtils'
const isArmCatalog = (catalog: unknown): boolean =>
  /^BR\d+(-\d+)?$/i.test(String(catalog || '').trim())

/** Snap 166-/oreja/brazo: motor completo (caras L, anti-solape). Fila recta: OGadapted. */
export function modularSnapNeedsFullEngine(dragCatalog: unknown, anchorCatalog: unknown): boolean {
  return (
    isModularCornerSnapCatalog(dragCatalog) ||
    isModularCornerSnapCatalog(anchorCatalog) ||
    isOreja(dragCatalog) ||
    isOreja(anchorCatalog) ||
    isArmCatalog(dragCatalog) ||
    isArmCatalog(anchorCatalog)
  )
}

export type ModularCollideResult = { snapped: boolean; side: 'left' | 'right' | null }

export type ModularCollideOptions = {
  forceReposition?: boolean
  /** Posición propuesta del item arrastrado (arrastre IKEA en vivo). */
  proposedPosition?: { x: number; y: number; z: number }
  forcedSide?: 'left' | 'right'
}

export function collideModularLinkedItems(
  dragId: AnyID,
  anchorId: AnyID,
  getCatalog: (id: AnyID) => unknown,
  collideItems: (
    dragId: AnyID,
    anchorId: AnyID,
    options?: ModularCollideOptions,
  ) => ModularCollideResult,
  collidePouffItems: (
    dragId: AnyID,
    anchorId: AnyID,
    options?: ModularCollideOptions,
  ) => ModularCollideResult,
  options?: ModularCollideOptions,
): ModularCollideResult {
  if (isPouff(getCatalog(dragId))) {
    return collidePouffItems(dragId, anchorId, options)
  }
  return collideItems(dragId, anchorId, options)
}
